<template>
    <Breadcrumbs main="Apps" title="To-Do" />
    <div class="container-fluid email-wrap bookmark-wrap todo-wrap">
        <div class="row">
            <todoSidebar />
            <addTask />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const todoSidebar = defineAsyncComponent(() => import("@/components/theme/todo/todoSidebar.vue"))
const addTask = defineAsyncComponent(() => import("@/components/theme/todo/addTask.vue"))

</script>